/* eslint-disable */
export default {
  noRecords: 'Geen recente opnamen gevonden.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
